// extracted by mini-css-extract-plugin
module.exports = {"title":"step_title__2Nhj1","content":"step_content__1DnJn","logoSvg":"step_logoSvg__2m9mZ","text":"step_text__nQMfX","skipStep":"step_skipStep__3k4qP"};